module.exports = __webpack_public_path__ + "static/page_layout_colors-2a830ea79cc08b57703386f93c5781be.png";